import { computed, openBlock, createElementBlock, createElementVNode, normalizeClass, Fragment, renderList, toDisplayString, pushScopeId, popScopeId } from "vue";
/* empty css                   */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _withScopeId = (n) => (pushScopeId("data-v-e2f3aec5"), n = n(), popScopeId(), n);
const _hoisted_1 = { class: "uikit-pagination" };
const _hoisted_2 = { class: "list" };
const _hoisted_3 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "u-hide-mobile" }, " < ", -1));
const _hoisted_4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "u-hide-desktop" }, " Précédent ", -1));
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
];
const _hoisted_6 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("li", { class: "item u-hide-desktop" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "u-mr-sm u-ml-sm" }, " | ")
], -1));
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "u-hide-mobile" }, " > ", -1));
const _hoisted_9 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "u-hide-desktop" }, " Suivant ", -1));
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
];
const _sfc_main = {
  __name: "Pagination",
  props: {
    pages: {
      type: Number,
      required: true
    },
    current: {
      type: Number,
      required: true
    }
  },
  emits: ["onChange"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const pageToDisplay = computed(() => {
      if (props.pages <= 5) {
        return Array.from({ length: props.pages }, (_, i) => i + 1);
      }
      if (props.current <= 3) {
        return [1, 2, 3, 4, 5];
      }
      if (props.current >= props.pages - 2) {
        return [props.pages - 4, props.pages - 3, props.pages - 2, props.pages - 1, props.pages];
      }
      return [props.current - 2, props.current - 1, props.current, props.current + 1, props.current + 2];
    });
    const handlePrevPageClick = () => {
      if (props.current > 1) {
        emit("onChange", props.current - 1);
      }
    };
    const handlePageClick = (page) => {
      emit("onChange", page);
    };
    const handleNextPageClick = () => {
      if (props.current < props.pages) {
        emit("onChange", props.current + 1);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("ul", _hoisted_2, [
          createElementVNode("li", {
            class: normalizeClass(["item", { disabled: __props.current <= 1 }]),
            onClick: handlePrevPageClick
          }, _hoisted_5, 2),
          _hoisted_6,
          (openBlock(true), createElementBlock(Fragment, null, renderList(pageToDisplay.value, (page) => {
            return openBlock(), createElementBlock("li", {
              key: page,
              class: normalizeClass(["item u-hide-mobile", {
                selected: page === __props.current
              }]),
              onClick: ($event) => handlePageClick(page)
            }, [
              createElementVNode("div", null, toDisplayString(page), 1)
            ], 10, _hoisted_7);
          }), 128)),
          createElementVNode("li", {
            class: normalizeClass(["item", { disabled: __props.current >= __props.pages }]),
            onClick: handleNextPageClick
          }, _hoisted_10, 2)
        ])
      ]);
    };
  }
};
const UikitPagination = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e2f3aec5"]]);
export {
  UikitPagination as default
};
//# sourceMappingURL=Pagination.vue.es.js.map
